"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ECollectionFlowActions;
(function (ECollectionFlowActions) {
    ECollectionFlowActions["NONE"] = "NONE";
    ECollectionFlowActions["CHANGE_STATUS_TO_DUE"] = "CHANGE_STATUS_TO_DUE";
    ECollectionFlowActions["CHANGE_STATUS_TO_OVERDUE"] = "CHANGE_STATUS_TO_OVERDUE";
    ECollectionFlowActions["CHANGE_STATUS_TO_DELINQUENT"] = "CHANGE_STATUS_TO_DELINQUENT";
    ECollectionFlowActions["ADD_TO_COLLECTION"] = "ADD_TO_COLLECTION";
    ECollectionFlowActions["CHANGE_STATUS_TO_WRITTEN_OFF"] = "CHANGE_STATUS_TO_WRITTEN_OFF";
    ECollectionFlowActions["CHANGE_STATUS_TO_WRITTEN_OFF_AND_CEASE_COLLECTIONS"] = "CHANGE_STATUS_TO_WRITTEN_OFF_AND_CEASE_COLLECTIONS";
})(ECollectionFlowActions = exports.ECollectionFlowActions || (exports.ECollectionFlowActions = {}));
var ECollectionHistoryType;
(function (ECollectionHistoryType) {
    ECollectionHistoryType["COLLECTION"] = "COLLECTION";
    ECollectionHistoryType["MANUAL"] = "MANUAL";
    ECollectionHistoryType["SETTINGS"] = "SETTINGS";
    ECollectionHistoryType["OTHER"] = "OTHER";
})(ECollectionHistoryType = exports.ECollectionHistoryType || (exports.ECollectionHistoryType = {}));
